import { render, staticRenderFns } from "./CourseListYw.vue?vue&type=template&id=4233f971"
import script from "./CourseListYw.vue?vue&type=script&lang=js"
export * from "./CourseListYw.vue?vue&type=script&lang=js"
import style0 from "./CourseListYw.vue?vue&type=style&index=0&id=4233f971&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports